<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <!-- 我的分数 -->
        <div class="main_r">
          <div class="mainr_top">
            <div><img src="@/assets/gerenzhongxin/geren16.png">
              我的测评
            </div>
          </div>
          <div class="xs_ul">
            <div class="xs_li" v-for="(item,index) in list" style="display: flex;
            flex-direction: row;">
              <div class="xs_li_l" style="width: 50px;">
                <!-- pc端 -->
                <span
                  style="margin-right: 10px;border: 1px solid #F53824;border-radius: 20px;width: 32px;text-align: center;">{{index+1}}</span>
              </div>
              <div style="line-height:58px; width: 100%;">
                <div style="display: flex;flex-direction: row;justify-content: space-around;">
                  <div class="xs_li_c" style="width: 65px;text-align: center;">
                    <div style="width: 100%;">
                      <figure class="wenjiansjh">
                        <figcaption style="font-size: 18px;font-weight: 600;">{{item.hsName}}
                        </figcaption>
                      </figure>
                    </div>
                  </div>

                  <div class="xs_li_c" v-if="userInfo.userRole == '2'||userInfo.userRole == '3'">
                    <span style="width: 100%;text-align: left;font-weight: 800;">{{item.spare2}}
                    </span>
                  </div>
                  <div class="xs_li_c" style="padding-left: 10px;width: 300px;">
                    <span style="width: 100%;text-align: left;">分数:
                    <b v-for="i in  gethsInfo(item.hsInfo)" style="padding-left: 10px;color: #e63233;">{{i.cname}}&nbsp;:&nbsp;{{i.value}}</b>
                    </span>
                  </div>
                  <div class="xs_li_c" style="">
                    <span style="width: 100%;text-align: left;">创建时间&nbsp;:&nbsp;<b style="color: #F53824;">{{item.creatTime}}</b>
                    </span>
                  </div>
                  <div style="width: 70px;margin-top: 15px;">
                    <span class="xs_li_r xs_li_r_e" style=""  @click="opencp(item)">
                      <span>查看测评</span>
                    </span>
                    <!-- <div class="xs_li_r" style="" @click="addUser(0,item)">
                      <span>信息修改</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="mieyou">
              没有更多学生了哟~
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu
    },
    data() {
      return {
        list:[],
        userInfo:this.$utils.getlocalStorage('userInfo')
      }
    },


    methods: {
      getdata() {
        let _this = this;
        _this.$req.queryAllByLimit("tcphistory", {
          pageSize: 0,
          pageNum: 0,
          queryObj: {
            hsuId:this.$utils.getlocalStorage('userInfo').userId
          }
        }).then(function(response) {
          _this.list = response.data
          _this.total = response.pages;
        })
      },
      gethsInfo(item){
        if(item!=null&&item!=''){
          return JSON.parse(item).slice(0,3)
        }
        return [];
      },
      opencp(item){
        console.log(item)
        let result = {
          name:item.hsName,
          count: JSON.parse(item.hsInfo),
          type:item.hsType,
          time:item.creatTime,
          spare2:item.spare2
        }
        this.$utils.setlocalStorage('cpresult',result);
        this.$router.push('/grzx_xinggeceping_result');
      }
    },
    created() {
      this.getdata();
    }
  }
</script>

<style scoped>
  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    margin-top: 90px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    min-height: 878px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }


  .duanxin {
    border: none;
    position: absolute;
    left: 340px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 0px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 0px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  input::placeholder {
    color: #a4a4a4;
  }

  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 690px;
    height: 520px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .uppwd {
    display: flex;
    flex-direction: row;
  }
























  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 我的学生 */
  .xs_ul {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* .xs_ul_you{width: 100%;height: auto; } */
  .xs_li {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 20px;
    width: 100%;
    /* height: 64px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background: url(../../assets/gerenzhongxin/wdxs2.png)no-repeat;
    background-size: 100% 100%;
  }

  .xs_li_r {
    padding: 0 10px;
    height: 28px;
    background: linear-gradient(180deg, #F53824 0%, #FE9603 100%);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .xs_li_r_e {
    background: unset;
    color: #F53824;
    border: 1px solid #F53824;
  }

  .xs_li_l {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure {
    display: flex;
    height: 100%;
    align-items: center;
  }

  .xs_li_l figure img {
    height: 46px;
    margin-right: 10px;
  }

  .xs_li_l figure figcaption {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
  }

  .xs_li_l span {
    margin-left: 0px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .xs_li_c {
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .xs_li_c span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .xs_li_c span:nth-of-type(2) {
    margin-left: 15px;
  }

  .mieyou {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }





  @media (min-width:750px) {
    .shoujifig {
      display: none !important;
    }
  }

  @media (max-width:750px) {
    .wenjiansjh {
      display: none !important;
    }

    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .manpin {
      padding: 20px 0;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .main_r {
      height: auto;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }



    /* 我的学生 */
    .xs_li {
      padding: 0 10px;
    }

    .xs_li_l figure img {
      height: 36px;
    }

    .xs_li_l figure figcaption {
      font-size: 15px;
      display: flex;
      flex-direction: column;
    }

    .xs_li_l figure figcaption span:nth-of-type(1) {
      color: #29A7E1;
    }

    .xs_li_l figure figcaption span:nth-of-type(2) {
      font-size: 10px;
    }

    .xs_li_l span {
      font-size: 15px;
      margin-left: 0px;
    }

    .xs_li_c {
      flex-direction: column-reverse;
      align-items: end;
      justify-content: center;
    }

    .xs_li_c span {
      font-size: 12px;
    }

    .xs_li_r {
      flex-direction: column;
      width: 45px;
      height: auto;
    }

    .mieyou {
      margin-top: 40px;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }


  }
</style>



// WEBPACK FOOTER //
// src/views/mine/h_cphistory.vue